import { useMembersContext } from '@/contexts/membersContext';
import { ContentType } from '@/types/contentType';
import ajax from '@/utils/ajax';

export interface ReferrerCodeLookupResponse {
  entity_id: string;
  entity_type: ContentType;
}

export const referrerCodeRepository = {
  BASE_PATH: '/api/referrer_code/',

  async lookup(host: string, code: string): Promise<ReferrerCodeLookupResponse[]> {
    const response = await ajax.get({
      url: `${host}${this.BASE_PATH}`,
      params: { code }
    });

    return response.data;
  }
};

export const ReferrerCodeRepository = () => {
  const { host } = useMembersContext();

  return {
    async lookup(code: string) {
      return referrerCodeRepository.lookup(host, code);
    }
  };
};
